var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('figure',{staticClass:"loader"},[_c('picture',{staticClass:"loader"},[_c('img',{staticClass:"loader",attrs:{"src":require("../assets/images/logos/loader.png"),"alt":"Loading..."}})]),_c('figcaption',[_vm._v("un instant de méditation")])])
}]

export { render, staticRenderFns }